<template>
  <div class="animated fadeIn">
    <b-modal
      centered
      header-class="notification__modal__header"
      :visible="hasRestrictions"
      ok-variant="#277053"
      id="notificationModal"
      title="ATENÇÃO"
      ok-only
    >
      <p>Checar anotações</p>
    </b-modal>
    <RestrictionAlertVue
      v-if="hasRestrictions"
      :hasRestrictions="hasRestrictions"
    />
    <template v-if="objSelected">
      <div class="row">
        <div class="col-md-12">
          <div
            class="card"
            style="background-color: #fbfbfb"
          >
            <div class="close-card pb-2">
              <small
                class="cursor-pointer"
                @click="onClose"
                >Fechar <i class="far fa-times-circle"></i
              ></small>
            </div>
            <div class="card-block pt-4">
              <!-- HEADER -->
              <input
                type="hidden"
                ref="myCopy"
                id="myCopy"
                name="myCopy"
                value=""
              />
              <div class="form-group row">
                <div class="col-md-6">
                  <b-avatar
                    :class="hasRestrictions ? 'danger-border' : ''"
                    size="4rem"
                    style="float: left; margin-right: 1.5rem; margin-top: 1rem"
                  >
                    <i
                      v-if="objSelected.pessoa.tipoPessoa === 'PF'"
                      style="font-size: 1.5rem"
                      class="far fa-user"
                    ></i>
                    <i
                      v-else
                      style="font-size: 1.5rem"
                      class="far fa-building"
                    ></i>
                  </b-avatar>
                  <div
                    class="cursor-pointer"
                    @click="onCopyName"
                  >
                    <strong style="font-size: 23px">{{
                      objSelected ? objSelected.pessoa.nomeAssociado : ''
                    }}</strong>
                    <small
                      ><i
                        class="fas fa-clone"
                        v-b-tooltip.hover
                        title="Clique para copiar"
                      ></i
                    ></small>
                  </div>
                  <span class="input-group w-sm-50">
                    <b-form-input
                      v-model="form.prinome.value"
                      :placeholder="$lang.Common.prinamePlaceholder"
                    />
                  </span>
                  <div style="margin-top: 0.5rem; margin-left: 5.5rem">
                    <div>
                      <i class="fas fa-user"></i>
                      <strong>Tipo Pessoa:</strong>&nbsp;{{
                        objSelected ? objSelected.pessoa.tipoPessoa : ''
                      }}
                    </div>
                    <div
                      class="cursor-pointer"
                      @click="onCopyDocument"
                    >
                      <i class="fas fa-id-card"></i> &nbsp;<strong
                        >{{
                          objSelected
                            ? getTipoPessoa(objSelected.pessoa.document) == 'PF'
                              ? 'CPF'
                              : 'CNPJ'
                            : ''
                        }}:&nbsp;</strong
                      >
                      {{
                        objSelected
                          ? onFormatDocument(objSelected.pessoa.document)
                          : ''
                      }}
                      <small
                        ><i
                          class="fas fa-clone"
                          v-b-tooltip.hover
                          title="Clique para copiar"
                        ></i
                      ></small>
                    </div>
                    <div
                      class="cursor-pointer"
                      @click="onCopyNumId"
                    >
                      <i class="fas fa-id-card"></i> &nbsp;<strong
                        >{{ $t('associates.number') }} :&nbsp;</strong
                      >
                      {{ objSelected ? objSelected.numId : '' }}
                      <small
                        ><i
                          class="fas fa-clone"
                          v-b-tooltip.hover
                          title="Clique para copiar"
                        ></i
                      ></small>
                    </div>
                    <div
                      v-if="
                        objSelected && objSelected.pessoa.tipoPessoa == 'PJ'
                      "
                    >
                      <i class="fas fa-calendar"></i> &nbsp;<strong
                        >Data de Abertura:&nbsp;</strong
                      >
                      &nbsp;{{
                        objSelected && objSelected.pessoa.dataNascimento
                          ? moment(
                              objSelected.pessoa.dataNascimento.substring(0, 19)
                            ).format('DD/MM/YYYY')
                          : ''
                      }}
                    </div>
                    <div v-else>
                      <i class="fas fa-calendar"></i> &nbsp;<strong
                        >Data de Nascimento:&nbsp;</strong
                      >{{
                        objSelected && objSelected.pessoa.dataNascimento
                          ? moment(
                              objSelected.pessoa.dataNascimento.substring(0, 19)
                            ).format('DD/MM/YYYY')
                          : ''
                      }}
                    </div>
                    <div v-if="objSelected.enableAssociateResume">
                      <div class="custom-activity-btn"
                        v-if="objSelected && objSelected.id !== null && !isLoading"
                        variant="link"
                        @click="showAssociadoModal(objSelected.pessoa.document)"
                      >
                      <i class="fas fa-user mr-1"></i> Detalhes do Associado
                      </div>
                      <AssociadoResumo
                        ref="AssociadoResumo"
                        :document="objSelected.pessoa.document"
                        v-if="showAssociadoResumeModal"
                        @hide-modal="showAssociadoResumeModal = false"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4 pt-2">
                  <div>
                    <i class="fas fa-users"> &nbsp;</i
                    ><strong>Clusterização:&nbsp;</strong>
                  </div>
                  <span
                    class="input-group"
                    style="margin-top: 0.3rem; margin-bottom: 0.5rem"
                  >
                    <b-form-select
                      v-model="form.clusterizacaoId.value"
                      :options="form.clusterizacaoId.options"
                    >
                      <template slot="first">
                        <option :value="null">
                          {{ $lang.Common.PlaceholderSelect }}
                        </option>
                      </template>
                    </b-form-select>
                  </span>
                  <div>
                    <i class="fas fa-building"></i> &nbsp;<strong
                      >PA:&nbsp;</strong
                    >{{
                      objSelected && objSelected.pa
                        ? objSelected.pa.numero +
                          ' - ' +
                          objSelected.pa.descricao
                        : ''
                    }}
                  </div>
                  <div>
                    <i class="far fa-calendar-check"></i> &nbsp;<strong
                      >Início do Relacionamento:&nbsp;</strong
                    >{{
                      objSelected && objSelected.inicioRelacionamento
                        ? moment(
                            objSelected.inicioRelacionamento.substring(0, 19)
                          ).format('DD/MM/YYYY')
                        : ''
                    }}
                  </div>
                  <div>
                    <i class="fas fa-file-contract"></i> &nbsp;<strong
                      >Última Renovação:&nbsp;</strong
                    >{{
                      objSelected && objSelected.ultimaRenovacao
                        ? moment(
                            objSelected.ultimaRenovacao.substring(0, 19)
                          ).format('DD/MM/YYYY')
                        : ''
                    }}
                  </div>
                </div>
                <div class="col-md-2 pt-2">
                  <div>
                    <i class="fas fa-exclamation-circle"></i>
                    <strong>Possíveis Pendências:</strong>
                    <div class="checkboxFilds ml-4">
                      <b-form-group class="mt-1 mb-0">
                        <b-form-checkbox
                          id="checkboxProtestado"
                          v-model="form.pendencias.notificado.value"
                        >
                          Protestado
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group>
                        <b-form-checkbox
                          id="checkboxAjuizado"
                          v-model="form.pendencias.ajuizado.value"
                        >
                          Ajuizado
                        </b-form-checkbox>
                      </b-form-group>
                      <b-form-group>
                        <b-form-checkbox
                          id="checkboxCobranca"
                          :disabled="true"
                          v-model="form.pendencias.cobranca.value"
                        >
                          Cobrança
                        </b-form-checkbox>
                        <b-form-checkbox
                          id="checkboxAbsoluta"
                          :disabled="true"
                          v-model="form.pendencias.impeditivaAbsoluta.value"
                        >
                          Impeditiva Absoluta
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-group row">
                <div class="col-md-6">
                  <div class="card">
                    <AssociateGerente :objSelected="objSelected" />
                  </div>
                  <div class="card">
                    <AssociateGerenteRel
                      :objSelected="objSelected"
                      :$lang="$lang"
                    />
                  </div>
                  <div v-if="modules.hasAssociadoLogradouro" class="card">
                    <AssociateLogradouro :address="address" />
                  </div>
                  <div v-if="modules.hasAssociadoContatos" class="card">
                    <AssociateContato
                      :phones="phones"
                      :mail="mail"
                    />
                  </div>
                  <div v-if="modules.hasAssociadoPessoasRelacionadas" class="card">
                    <AssociateRelacionamento
                      :personRelations="personRelations"
                      :phones="phones"
                    />
                  </div>
                  <div v-if="modules.hasAssociadoGrupoEconomico" class="card">
                    <AssociateGrupoEco
                      :pessoaGrupoEconomicoList="pessoaGrupoEconomicoList"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    v-if="objSelected && objSelected.pessoa.tipoPessoa == 'PF' && modules.hasAssociadoInformacoesPessoais"
                    class="card"
                  >
                    <AssociateInfosPF :objSelected="objSelected" />
                  </div>
                  <div v-if="modules.hasAssociadoMatricula || modules.hasAssociadoContaCorrente" class="card">
                    <AssociateInfosContas
                      :contaCorrenteList="contaCorrenteList"
                      :matriculaList="matriculaList"
                    />
                  </div>
                  <div v-if="modules.hasAssociadoContaCorrente || modules.hasAssociadoContratosVigentes" class="card cardScroll">
                    <AssociateOperacoesFinanceiras
                      :objSelected="objSelected"
                      :document="document"
                      :productSelected="productSelected"
                      :bacenSelected="bacenSelected"
                      :subBacenSelected="subBacenSelected"
                      :boardColumn="boardTypes"
                      @scrollToContratosVigentes="$refs.AssociateDetailsTabs.handleShowVigentes()"
                    />
                  </div>
                  <div v-if="modules.hasAssociadoInformacoesAssociado" class="card">
                    <AssociateInfos
                      :objSelected="objSelected"
                      :indicadorPep="indicadorPep"
                      :nivelRiscoPld="nivelRiscoPld"
                      :grossMonthlyIncome="grossMonthlyIncome"
                      :form="form"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="form-group row pt-2 pb-2">
                <div class="col-md-12 text-right">
                  <button
                    type="button"
                    class="btn btn-third btn-sm"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonBack"
                    @click="onClose"
                  >
                    <i class="fas fa-undo"></i>
                    <span class="d-md-down-none">{{
                      $lang.Common.Buttons.Back
                    }}</span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-third btn-sm"
                    v-b-tooltip.hover
                    :title="$lang.Common.Tooltip.ButtonSave"
                    @click="onUpdate"
                  >
                    <i class="fa fa-check-circle"></i>
                    <span class="d-md-down-none">{{
                      $lang.Common.Buttons.Save
                    }}</span></button
                  >&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalCard
          ref="ModalCard"
          v-if="selectedCard"
          :boardColumns="[]"
          @hideModal="closeCard"
          v-bind:key="selectedCard"
          :cardId="selectedCard"
        />
      </div>
    </template>
    <AssociateDetailsTabs
      v-show="objSelected"
      ref="AssociateDetailsTabs"
      id="associateDetailsTabs"
    />
  </div>
</template>
<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import RestrictionAlertVue from '@/components/UI/restrictionAlert/restrictionAlert'
import Tools from '@/components/tools/Tools.js'
import boardTypes from '@/enums/enumBoardTypes.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import AssociateDetailsTabs from '@/views/private/associate/components/AssociateDetailsTabs.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import 'vue-select/dist/vue-select.css'
import ModulesLite from '@/shared/mixins/modulesLite'

import ContaCorrenteRepository from '@/shared/http/repositories/business/contacorrente.js'
import ContratosVigentesRepository from '@/shared/http/repositories/business/contratosvigentes.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'

// import ContaCorrente from '@/shared/http/repositories/business/averagebalancecco.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ContaCapital from '@/shared/http/repositories/business/capitalaccount.js'
import EconomicGroupRepository from '@/shared/http/repositories/business/economicgroup.js'
import PatrimonyRepository from '@/shared/http/repositories/business/patrimony.js'
import PldRepository from '@/shared/http/repositories/business/pld.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import FuncionarioRepository from '@/shared/http/repositories/configurations/employee.js'
import PARepository from '@/shared/http/repositories/configurations/pa'

import TabPessoasGrupoEconomico from '@/views/private/associate/tabs/pessoasgrupoeconomico.vue'

import AssociateContato from '@/views/private/associate/components/AssociateContato.vue'
import AssociateGerente from '@/views/private/associate/components/AssociateGerente.vue'
import AssociateGerenteRel from '@/views/private/associate/components/AssociateGerenteRel.vue'
import AssociateGrupoEco from '@/views/private/associate/components/AssociateGrupoEco.vue'
import AssociateInfos from '@/views/private/associate/components/AssociateInfos.vue'
import AssociateInfosContas from '@/views/private/associate/components/AssociateInfosContas.vue'
import AssociateInfosPF from '@/views/private/associate/components/AssociateInfosPF.vue'
import AssociateLogradouro from '@/views/private/associate/components/AssociateLogradouro.vue'
import AssociateOperacoesFinanceiras from '@/views/private/associate/components/AssociateOperacoesFinanceiras.vue'
import AssociateRelacionamento from '@/views/private/associate/components/AssociateRelacionamento.vue'
import AssociadoResumo from '@/components/nexum/modals/AssociadoResumo.vue'

const formDetail = {
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '4',
    noResize: true
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  gerenteRelacionamento: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  prinome: {
    value: null,
    required: false,
    state: null
  },
  pendencias: {
    ajuizado: {
      value: null,
      required: false,
      state: null
    },
    notificado: {
      value: null,
      required: false,
      state: null
    },
    cobranca: {
      value: null,
      required: false,
      state: null
    },
    impeditivaAbsoluta: {
      value: null,
      required: false,
      state: null
    }
  }
}

export default {
  name: 'AssociatePage',
  mixins: [ActionsForm, ModulesLite],
  data () {
    return {
      form: formDetail,
      boardTypes: boardTypes,
      financeResume: {},
      objSelected: null,
      selectedCard: null,
      screenW: screen.width,
      patrimony: null,
      nivelRiscoPld: null,
      indicadorPep: null,
      contaCorrenteList: [],
      matriculaList: [],
      paGerenteRelacionamento: [],
      pessoaGrupoEconomicoList: [],
      paGerente: [],
      productOptions: [],
      productSelected: null,
      bacenOptions: [],
      bacenSelected: null,
      subBacenOptions: [],
      subBacenSelected: null,
      hasRestrictions: false,
      isBusyInfosAssociado: true,
      isBusyInfosFinance: true,
      moneyBlur: true,
      maiorQueDezContratos: false,
      showAssociadoResumeModal: false
    }
  },
  components: {
    TabPessoasGrupoEconomico,
    RestrictionAlertVue,
    AssociateDetailsTabs,
    DefaultButton,
    ModalCard,
    AssociateGerente,
    AssociateGerenteRel,
    AssociateLogradouro,
    AssociateContato,
    AssociateRelacionamento,
    AssociateGrupoEco,
    AssociateInfosPF,
    AssociateInfosContas,
    AssociateOperacoesFinanceiras,
    AssociateInfos,
    AssociadoResumo
  },
  async mounted () {
    await this.onLoadAssociado(this.associateId)
    await this.onLoadAllCluster()
    await this.onLoadAllFuncionarios()
  },
  watch: {
    productSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(this.document, newValue)
      }
    },
    bacenSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(
          this.document,
          this.productSelected,
          newValue
        )
      }
    },
    subBacenSelected: {
      handler: function (newValue) {
        this.onLoadContratosVigentesRepository(
          this.document,
          this.productSelected,
          this.bacenSelected,
          newValue
        )
      }
    }
  },
  computed: {
    grossMonthlyIncome () {
      let result = 'R$ 0,00'
      if (this.objSelected) {
        result = Tools.formatMoneyBR(this.objSelected.rendaBrutaMensal)
      }
      return result.replace(/^R\$ /, '')
    },
    address () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.endereco) {
        result = this.objSelected.pessoa.endereco
      }
      return result
    },
    phones () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.telefone) {
        result = this.objSelected.pessoa.telefone
      }
      return result
    },
    mail () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.email) {
        result = this.objSelected.pessoa.email
      }
      return result
    },
    personRelations () {
      let result = null
      if (this.objSelected && this.objSelected.pessoaRelacionada) {
        result = this.objSelected.pessoaRelacionada
      }
      return result
    },
    initialName: function () {
      let result = ''
      if (this.objSelected && this.objSelected.nome) {
        var names = this.objSelected.nome.split(' ')
        if (names && names.length > 1) {
          result =
            names[0].substring(0, 1) + names[names.length - 1].substring(0, 1)
        } else if (names && names.length > 0) {
          result = names[0].substring(0, 1)
        }
      }
      return result
    },
    personTypeByDocument: function () {
      let result = 'PF'
      if (this.objSelected && this.objSelected.document) {
        let doc = this.objSelected.document.replace('.', '')
        doc = doc.replace('.', '')
        doc = doc.replace('-', '')
        doc = doc.replace('/', '')

        if (doc.length > 11) {
          result = 'PJ'
        }
      }
      return result
    },
    associateId () {
      return this.$route.params.associateId
    },
    backUrl: function () {
      return 'Associate'
    }
  },
  methods: {
    async onLoadAssociado (id) {
      try {
        loading.push()

        this.form.clusterizacaoId.value = null
        this.form.observacao.value = ''
        this.form.gerenteRelacionamento.value = null
        this.form.prinome.value = null
        this.form.pendencias.notificado.value = false
        this.form.pendencias.ajuizado.value = false
        this.form.pendencias.cobranca.value = false
        this.form.pendencias.impeditivaAbsoluta.value = false

        const response = await AssociateRepository.GetById(id)

        if (!response || !response.data) return

        const data = response.data
        this.objSelected = data
        this.checkPendencias(data)

        this.showAssociadoResumeModal = this.objSelected.enableAssociateResume

        this.$refs.AssociateDetailsTabs.objSelected = data
        this.$refs.AssociateDetailsTabs.onCallDependences(data.pessoa.document)

        this.onCallDependences(data.pessoa.document)

        this.form.clusterizacaoId.value = data.clusterizacaoDTO
          ? data.clusterizacaoDTO.id
          : null
        this.form.observacao.value = data.observacao ? data.observacao : null
        this.form.prinome.value = data.pessoa.prinome
          ? data.pessoa.prinome
          : null
        this.form.pendencias.notificado.value = data.pendencias
          ? data.pendencias.notificado
          : false
        this.form.pendencias.ajuizado.value = data.pendencias
          ? data.pendencias.ajuizado
          : false
        this.form.pendencias.cobranca.value = data.pendencias
          ? data.pendencias.cobranca
          : false
        this.form.pendencias.impeditivaAbsoluta.value = data.pendencias
          ? data.pendencias.impeditivaAbsoluta
          : false
        if (data.gerenteRelacionamento) {
          this.form.gerenteRelacionamento.value = {
            gerenteRelacionamentoId: data.gerenteRelacionamento.id,
            paId: data.gerenteRelacionamento.paId,
            nome: data.gerenteRelacionamento.pessoa.nome
          }
        }
        if (this.showAssociadoResumeModal) {
          this.$nextTick(() => {
            if (this.$refs.AssociadoResumo) {
              this.$refs.AssociadoResumo.openResumoAssociado()
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        loading.close()
      }
    },
    closeModal () {
      this.$emit('hide-modal')
    },
    checkPendencias (person) {
      if (!person.pendencias) {
        this.hasRestrictions = false
        return
      }

      this.hasRestrictions = Object.values(person.pendencias).some(
        (item) => item === true
      )
    },
    onCallDependences (document) {
      this.onLoadPld(document)
      this.onLoadAllPatrimony(document)
      this.onLoadContaCorrente(document)
      this.onLoadContaCapital(document)
      this.onLoadTabPessoasEconomicGroup(document)
    },
    async onLoadAllCluster () {
      try {
        loading.push()

        const response = await ClusterRepository.GetAll()

        if (!response) return

        this.form.clusterizacaoId.options = this.onResultDropdown(
          response,
          null,
          (f) => f.descricao
        )
      } catch (error) {
        this.onException(error)
      } finally {
        loading.close()
      }
    },
    async onLoadAllFuncionarios () {
      try {
        loading.push()

        const response = await FuncionarioRepository.GetAll()

        if (!response) return

        this.form.gerenteRelacionamento.options =
          this.setDropdownGerentesRelacionamentoOptions(response)
      } catch (error) {
        this.onException(error)
      } finally {
        loading.close()
      }
    },
    onLoadPld (document) {
      this.nivelRiscoPld = null
      this.indicadorPep = null

      PldRepository.Search(document, 50, 0)
        .then((response) => {
          if (response.data.content.length > 0) {
            this.nivelRiscoPld = response.data.content[0].nivelRiscoPLD
            this.indicadorPep = response.data.content[0].indicadorPep
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onLoadAllPatrimony (document) {
      loading.push()
      this.patrimony = null
      PatrimonyRepository.Search(document, 50, 0)
        .then((response) => {
          if (response.data.content.length > 0) {
            this.patrimony = response.data.content
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onLoadContaCorrente (document) {
      ContaCorrenteRepository.Search(document)
        .then((response) => {
          let setOfContas = new Set()
          this.contaCorrenteList = response.data.content.reduce((acc, x) => {
            if (!setOfContas.has(x.numeroContaCorrente)) {
              setOfContas.add(x.numeroContaCorrente)
              acc.push(x)
            }
            return acc
          }, [])
        })
        .catch(this.onException)
    },
    onLoadContaCapital (document) {
      ContaCapital.Search(document, 500, 0)
        .then((response) => {
          console.log(response)
          let setOfContas = new Set()
          this.matriculaList = response.data.content.reduce((acc, x) => {
            if (!setOfContas.has(x.numMatricula)) {
              setOfContas.add(x.numMatricula)
              acc.push(x)
            }
            return acc
          }, [])
        })
        .catch(this.onException)
    },
    showAssociadoModal (document) {
      this.selectedDocument = document
      this.showAssociadoResumeModal = true
      this.$nextTick(() => {
        if (this.$refs.AssociadoResumo) {
          this.$refs.AssociadoResumo.openResumoAssociado()
        }
      })
    },
    onLoadTabPessoasEconomicGroup (document) {
      console.log('onLoadTabPessoasEconomicGroup')
      loading.push()
      this.document = document
      EconomicGroupRepository.SearchPeopleIn(document, 500, 0)
        .then((response) => {
          this.pessoaGrupoEconomicoList = response.data.content
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.close()
    },
    onClose () {
      this.$router.push({ name: 'Associate' })
    },
    async onLoadFinanceResume () {
      const document = this.objSelected.pessoa.document

      await this.onLoadContaCorrenteRepository(document)
      await this.onLoadContratosVigentesRepository(document)
      await this.onLoadCardsFromAssociate(document)

      this.isBusyInfosFinance = !this.isBusyInfosFinance
    },
    async onLoadContaCorrenteRepository (document) {
      await ContaCorrenteRepository.Search(document, 200, 0)
        .then((response) => {
          const accounts = response.data.content
          this.financeResume.accounts = accounts
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async onLoadContratosVigentesRepository (
      document,
      productSelected,
      bacenSelected,
      subBacenSelected
    ) {
      try {
        const objFilter = {
          params: {
            modalidadeProduto: productSelected,
            submodalidadeBacen: subBacenSelected,
            modalidadeBacen: bacenSelected,
            document: document,
            page: 0,
            size: 200
          }
        }

        await ContratosVigentesRepository.Search(
          objFilter.params.document,
          this.$refs.tableGrid.pagingLimit,
          this.$refs.tableGrid.pagingIndex
        )
          .then((response) => {
            const contracts = response.data.content
            const pageable = response.data.pageable
            this.financeResume.contracts = contracts
            this.maiorQueDezContratos = pageable.totalElements > 10
          })
          .catch((err) => {
            console.error('Erro ao buscar contratos:', err)
          })
        await ContratosVigentesRepository.SearchByModalidadeProduto(
          document,
          200,
          0
        )
          .then((response) => {
            this.productOptions = response.data
          })
          .catch((err) => {
            console.error(
              'Erro ao buscar contratos por modalidade de produto:',
              err
            )
          })
        await ContratosVigentesRepository.SearchBySubmodalidadeBacen(
          document,
          200,
          0
        )
          .then((response) => {
            this.subBacenOptions = response.data
          })
          .catch((err) => {
            console.error(
              'Erro ao buscar contratos por submodalidade Bacen:',
              err
            )
          })
        await ContratosVigentesRepository.SearchByModalidadeBacen(
          document,
          200,
          0
        ).then((response) => {
          this.bacenOptions = response.data
        })
      } catch (error) {
        console.error('Erro geral:', error)
      }
    },
    async onLoadCardsFromAssociate (document) {
      await CardRepository.SearchAllByDocument(document, 200, 0)
        .then(async (response) => {
          const cards = response.data.content
          let cardsCobranca = this.splitCardsByType(
            cards,
            this.boardTypes.COBRANCA
          )
          let cardsAjuizamento = this.splitCardsByType(
            cards,
            this.boardTypes.AJUIZAMENTO
          )

          this.financeResume.cards = {
            cobranca: cardsCobranca,
            ajuizamento: cardsAjuizamento
          }
          this.financeResume.cobrancaProducts =
            await this.getProdutosFromCobranca(cardsCobranca)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async getProdutosFromCobranca (cards) {
      let allProducts = []

      for (const card of cards) {
        try {
          const response = await CardProductRepository.Search(card.id, 200, 0)
          const products = response.data.content
          if (products.length) allProducts.push(...products)
        } catch (err) {
          console.error(err)
        }
      }
      return allProducts
    },
    setDropdownGerentesRelacionamentoOptions (response) {
      let result = []
      let data = response.data.content
      for (let i in data) {
        result.push({
          gerenteRelacionamentoId: data[i].id,
          paId: data[i].paId,
          nome: data[i].pessoa.nome
        })
      }

      return result
    },
    onFormatMoney (value) {
      let result = 'R$ 0,00'
      if (value) {
        result = Tools.formatMoneyBR(value)
      }
      return result
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    },
    onCopyName () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.nome)
      }
    },
    onCopyDocument () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.document)
      }
    },
    onCopyNumId () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.numId)
      }
    },
    onCopy (value) {
      if (value) {
        var obj = this.$refs.myCopy
        obj.value = value
        obj.setAttribute('type', 'text')
        obj.select()
        document.execCommand('copy')
        toast.success(this.$lang.Common.Alerts.CopySuccess)
        obj.setAttribute('type', 'hidden')
      }
    },
    onUpdate () {
      const dataUpdate = {
        id: this.objSelected.id,
        document: this.objSelected.pessoa.document,
        num: this.objSelected.num,
        gerenteId: this.objSelected.gerente ? this.objSelected.gerente.id : 0,
        gerenteRelacionamentoId: this.form.gerenteRelacionamento.value
          ? this.form.gerenteRelacionamento.value.gerenteRelacionamentoId
          : 0,
        clusterizacaoId: this.form.clusterizacaoId.value || 0,
        prinome: this.form.prinome.value || null,
        enderecosId: [],
        telefonesId: [],
        tipoPessoa: this.objSelected.pessoa.tipoPessoa,
        nomeAssociado: this.objSelected.pessoa.nome,
        inicioRelacionamento: this.objSelected.inicioRelacionamento,
        ultimaRenovacao: this.objSelected.ultimaRenovacao,
        email: this.objSelected.pessoa.email,
        telefoneCelular: '',
        telefoneComercial: '',
        telefoneResidencial: '',
        rendaBrutaMensal: this.objSelected.rendaBrutaMensal,
        tipoRenda: this.objSelected.tipoRenda,
        vinculoEmpregaticio: this.objSelected.vinculoEmpregaticio,
        descricaoProfissao: this.objSelected.descricaoProfissao,
        atividadeEconomica: this.objSelected.atividadeEconomica,
        descricaoCategoria: this.objSelected.descricaoCategoria,
        dataNascimento: this.objSelected.pessoa.dataNascimento,
        observacao: this.form.observacao.value,
        pendencias: {},
        notificado: this.form.pendencias.notificado.value,
        ajuizado: this.form.pendencias.ajuizado.value,
        cobranca: this.form.pendencias.cobranca.value,
        impeditivaAbsoluta: this.form.pendencias.impeditivaAbsoluta.value
      }
      dataUpdate.enderecosId = []
      this.objSelected.pessoa.endereco.forEach((element) => {
        dataUpdate.enderecosId.push(element.id)
      })

      dataUpdate.telefonesId = []
      this.objSelected.pessoa.telefone.forEach((element) => {
        dataUpdate.telefonesId.push(element.id)
      })

      dataUpdate.pendencias.notificado = this.form.pendencias.notificado.value
      dataUpdate.pendencias.ajuizado = this.form.pendencias.ajuizado.value
      dataUpdate.pendencias.cobranca = this.form.pendencias.cobranca.value
      dataUpdate.pendencias.impeditivaAbsoluta =
        this.form.pendencias.impeditivaAbsoluta.value

      loading.push()
      AssociateRepository.Update(dataUpdate.id, dataUpdate)

        .then(() => {
          loading.close()
          this.checkPendencias(dataUpdate)
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    getPaGerente (paIdList) {
      this.paGerente = []
      for (let i in paIdList) {
        PARepository.GetById(paIdList[i])
          .then((res) => {
            this.paGerente.push(res.data)
          })
          .catch(this.onException)
      }
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getTipoPessoa (document) {
      return Tools.checkDocumentType(document)
    },
    splitCardsByType (cards, type) {
      let cardsFromType = []
      cards.forEach((card) => {
        if (card.boardColumn.board.tipoBoard === type) {
          cardsFromType.push(card)
        }
      })
      return cardsFromType
    },
    formatDateTimeForms (obj) {
      return obj.split('T')[0].split('-').reverse().join('/')
    },
    toggleBusyInfosAssociado () {
      this.isBusyInfosAssociado = !this.isBusyInfosAssociado
    },
    toggleMoneyBlur () {
      this.moneyBlur = !this.moneyBlur
    },
    openConversation (contact) {
      this.$router.push({
        name: 'Atendimento',
        params: {
          newConversation: {
            nome: this.objSelected.pessoa.nome,
            numero: contact.telefone
          }
        }
      })
    },
    openAssociatePageByRelacionamento (document) {
      AssociateRepository.GetByDocument(document)
        .then((response) => {
          response.data.content.length > 0
            ? this.openAssociatePage(response.data.content[0].id)
            : toast.error(' ATENÇÃO! Relacionamento não é um associado')
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'AssociatePage',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
      // window.open(routeData.href)
      this.$router.go()
    },
    handleShowVigentes () {
      const target = document.getElementById('associateDetailsTabs')
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' })
      }
      this.$refs.AssociateDetailsTabs.handleShowVigentes()
    },
    toastInfo () {
      toast.info('Esta funcionalidade ainda não está disponível no seu nxCoop.')
    }
  }
}
</script>
<style lang="scss">
.tabsScroll {
  div {
    ul {
      overflow-x: overlay;
      flex-wrap: nowrap;
    }
  }
}
// associate__info__rows__group
.associate__info__rows {
  &__container {
    margin: 1rem 0 2.5rem 0;
  }

  &__group {
    margin-bottom: 1.75rem;

    &__title {
      font-size: 1.15rem;
      text-transform: uppercase;
      font-weight: 600;
      margin-bottom: 0.25rem;
    }
  }
}

.row {
  p {
    margin: 0;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    padding: 8px 0;
    border-bottom: solid 1px #d9d9d9;
  }

  &__type {
    text-transform: capitalize;
  }

  &__description {
    text-transform: capitalize;
    font-weight: 600;
    text-align: justify;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}

.money__blur {
  filter: blur(3px);
}

.notification__modal__header {
  background-color: #ffa500 !important;
  background-color: #ff0000 !important;
}

#notificationModal {
  p {
    font-size: 1rem;
  }

  .btn {
    color: #fff;
    background-color: #04a791 !important;
  }
}
</style>

<style scoped>
td {
  padding: 0 15px;
}

ul {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}

li {
  float: left;
  margin: 0 30px;
}

.title-tab-configuration {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #5d626c;
}

.title-tab-configuration a {
  text-decoration: underline;
  color: #04a791;
}

.close-card {
  text-align: right;
  display: block;
  right: 10px;
  position: absolute;
  top: 10px;
  z-index: 999;
}

card-header .nav.nav-tabs .nav-link,
.card-header .nav.nav-tabs .navbar .dropdown-toggle,
.navbar .card-header .nav.nav-tabs .dropdown-toggle {
  padding: 0.75rem 0.625rem;
  color: #04a791;
  border-top: 0;
}

.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: 0px;
}

.p-1 {
  padding: 0.85rem !important;
}

.custom-activity-btn {
  width: 220px;
  background-color: #1baca0;
  border-color: #1baca0;
  color: white;
  border-radius: 20px;
  padding: 10px 20px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  margin-top: 20px;
  cursor: pointer;
}

.custom-activity-btn:hover {
  background-color: #1baca0;
  border-color: #1baca0;
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

@media (min-width: 576px) {
  .w-sm-50 {
    width: 75% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/pages/AssociatePage.vue